import {Injectable} from "@angular/core";
import {SystemApp} from "../../constans/SystemConfigurations";
import {Router, ActivatedRoute, Params} from '@angular/router';
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {Color, Size} from "../../app.models";

@Injectable()

export class ApiUrl{

  constructor(private router: Router, private activeRouter: ActivatedRoute, public http:HttpClient) {}

  private apikTenant = this.getCookie('apiKey')
  private externalURL = this.getCookie('external_apiUrl')

  public getJWTToken(){
    // if(localStorage.getItem('token')){
    //   const token = 'Token '+ (localStorage.getItem('token') !=null ?localStorage.getItem('token')+"":'');
    //   return token;
    // }
    return "af13d58adbdccd6969639aee1dd9d360e09bcf5e";
  }

  public getCookie(cname:string): string{
    const name = cname + "="
    const ca = document.cookie.split(';')
    for(let i = 0; i < ca.length; i++){
      let c = ca[i];
      while (c.charAt(0) == ' '){
        c = c.substring(1);
      }
      if(c.indexOf(name) == 0){
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  getSliders(): string {
    return SystemApp.base_url_api + '/api/slider/'
  }

  getColor(): string {
    return SystemApp.base_url_api + '/api/colors/'
  }
  getSize(): string {
    return SystemApp.base_url_api + '/api/sizes/'
  }

  getProducts(): string {
    return SystemApp.base_url_api + '/api/product/'
  }

  getSearchProductsUrl(): string {
    return SystemApp.base_url_api + '/api/product/search'
  }
  getCategories(): string {
    return SystemApp.base_url_api + '/api/mainCategory/'
  }

  getBanners(): string {
    return SystemApp.base_url_api + '/api/banners/'
  }

  getBrowserSearch(query: string) {
    return SystemApp.base_url_api + '/api/browserSearch?q='+query
  }

  getProduct(id): string {
    return SystemApp.base_url_api + '/api/product/' + id + "/";
  }

  getStoreByUserToken(): string {
    return SystemApp.base_url_api + '/store/store_info/';
  }

  getStores(): string {
    return SystemApp.base_url_api + '/api/store/';
  }

  loginUser(): string{
    return SystemApp.base_url_api + '/api-token-auth/'
  }

  getCategory(): string {
    return SystemApp.base_url_api + '/api/mainCategory/';
  }

  getBrands(): string {
    return SystemApp.base_url_api + '/api/brands/';
  }
  getOrder(): string {
    return SystemApp.base_url_api + '/api/orders/';
  }
  getUserDetails(): string {
    return SystemApp.base_url_api + '/api/user/';
  }
  getBanner(): string {
    return SystemApp.base_url_api + '/api/banners/';
  }
  getSlider(): string {
    return SystemApp.base_url_api + '/api/slider/';
  }
  getVideo(): string {
    return SystemApp.base_url_api + '/api/video/';
  }
}
